import React from 'react';
import { FluentProvider } from '@fluentui/react-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SchedulingPage } from './components/scheduling/SchedulingPage';
import { brTheme } from './theme/brTheme';
import './styles/bookingsShell.scss';

const queryClient = new QueryClient();

export const BookingsExperience: React.FC = () => {
  return (
    <section className="bookings-page-section">
      <QueryClientProvider client={queryClient}>
        <FluentProvider theme={brTheme} style={{ backgroundColor: 'transparent' }}>
          <SchedulingPage />
        </FluentProvider>
      </QueryClientProvider>
    </section>
  );
};
